module.exports = __webpack_public_path__ + "img/applet.1352a2d7.png";